// this is an incomplete list of metadata keys
export const ClerkMetadataKeys = {
  PREBUILT_ENABLED: "prebuiltEnabled",
  COPY_BEHAVIOR: "copyBehavior",
  LANGUAGE: "language",
  CUSTOM_SIGNATURE: "custom_signature",
  PHYSICAL_EXAM_MODE: "physical_exam_mode",
  PREBUILT_ABBREVIATIONS: "prebuilt_abbreviations",
  ONBOARDED_SCRIBE_BASIC: "onboarded_scribe_basic",
  ONBOARDED_TEMPLATES_PAGE: "onboarded_templates_page",
  ONBOARDED_TEMPLATE_EDITOR: "onboarded_template_editor",
  SPECIALTY: "specialty",
} as const;